import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { StyledFullWidthTextarea } from "./styles";

type Props = {
    labelKey: string;
    placeholderKey: string;
    value: string;
    maxLength: number;
    onChange: (value: string) => void;
    counterDataAutomation?: string;
};

const renderCount = (value: string, max: number) => `${value.length}/${max}`;

export const WizardLimitedTextareaField = ({
    labelKey,
    placeholderKey,
    value,
    maxLength,
    onChange,
    counterDataAutomation,
}: Props) => {
    const { translate } = useTranslate();

    const handleChange = (next: string | undefined) => {
        onChange(typeof next === "string" ? next.slice(0, maxLength) : "");
    };

    return (
        <Stack
            gap="8px"
            width="100%"
        >
            <Flex
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon["500"]}
                >
                    {translate(labelKey)}
                </Text>
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon["300"]}
                    data-automation={counterDataAutomation}
                >
                    {renderCount(value, maxLength)}
                </Text>
            </Flex>
            <StyledFullWidthTextarea
                value={value}
                onChange={handleChange}
                placeholder={translate(placeholderKey)}
            />
        </Stack>
    );
};
